<template>
    <q-btn
        class="text-body1"
        :class="{ 'button': !portfolioStyle, 'portfolio_btn': portfolioStyle }"
        :label="label"
        :loading="loading"
        :disable="disable"
        no-caps
        text-color="white"
        :outline="outline"
        :icon="icon"
    />
</template>

<script>
export default {
    name: 'NextButton',
    props: {
        label: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        disable: {
            type: Boolean,
            default: false,
        },
        portfolioStyle: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: undefined,
        },
    },
};
</script>

<style scoped lang="scss">
    .button {
        background: linear-gradient(225deg, #18C8FF 14.89%, #933FFE 85.85%);
        border-radius: 12px;
        height: 44px;
    }
    .portfolio_btn {
        background: linear-gradient(292deg, rgba(160, 100, 255, 0.2) 0%, rgba(10, 0, 25, 0) 100%), rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(25px);
        border-radius: 12px;
        height: 44px;
    }
</style>
